import { NotificationBase } from './notification-base';

export class NotificationJob extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected viewNotification(): void {
    this.navCtrl.navigateForward(`jobs/view/${this.item.id}`, { queryParams: { eventSource: this.item.event_source } });
  }
}
